export function stopSpeech() {
  try {
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  } catch {}
}

export function pauseAllAudios() {
  // Pausa <audio> nativos
  document.querySelectorAll('audio').forEach(a => {
    try {
      a.pause();
      // Opcional: a.currentTime = 0; // si quieres reiniciar
    } catch {}
  });

  // Pausa <video> que solo reproduzcan audio (por si tenías vídeos "audio-only")
  document.querySelectorAll('video').forEach(v => {
    try {
      if (!v.paused && v.muted === false) {
        // no lo paramos si es el que acaba de iniciar (se maneja con "exceptEl" abajo)
      }
    } catch {}
  });

  stopSpeech();
}

/**
 * Pausa TODO el audio (HTMLAudioElements y TTS) y deja intacto el elemento "exceptEl" (el vídeo que acaba de iniciar).
 */
export function pauseAllMediaExcept(exceptEl) {
  // 1) Texto a voz
  stopSpeech();

  // 2) Audios HTML
  document.querySelectorAll('audio').forEach(a => {
    if (a !== exceptEl) {
      try { a.pause(); } catch {}
    }
  });

  // 3) Otros vídeos que estuvieran sonando (opcional)
  document.querySelectorAll('video').forEach(v => {
    if (v !== exceptEl) {
      try { v.pause(); } catch {}
    }
  });
}

/**
 * Para usar cuando abras un modal/página de vídeo antes de reproducir nada.
 */
export function prepareForVideoOpen() {
  stopSpeech();
  pauseAllAudios();
}